import { useQuery } from '@tanstack/react-query';
import { getRoverMilestones } from '@/api/Rover/applicationTDM';
import { getMilestones } from '../../../api/Sherpa/Project/modules/ProjectTdm';
import { TdmReactQueryKey } from '../../../constants/ReactQueryKeys';
import type { QueryParamsInterface } from '../../../types/Shared';

interface IMilestonesHookProps {
  params?: QueryParamsInterface;
  onSuccess?: (data: any) => void;
  onError?: (data: any) => void;
  enabled?: boolean;
}

export const useMilestones = ({ params, onSuccess, onError, enabled }: IMilestonesHookProps) => {
  return useQuery({
    queryKey: [TdmReactQueryKey.GET_PROJECT_MILESTONES, params],
    queryFn: () => getMilestones({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
    enabled,
  });
};

export const useRoverMilestones = ({ params, onSuccess, onError }: IMilestonesHookProps) => {
  return useQuery({
    queryKey: [TdmReactQueryKey.GET_APPLICATION_MILESTONES, params],
    queryFn: () => getRoverMilestones({ params }),
    onSuccess,
    onError,
    keepPreviousData: true,
    staleTime: 30000,
  });
};
